import { Box } from '@mui/material';
import { PopupWidget } from 'react-calendly';
import { Icon } from '@iconify/react';
import './CalendarDemo.scss';

const CalendarDemo = () => {
  const icon: any = <Icon icon='majesticons:arrow-right' className='footer-icon' />;

  return (
    <>
      <Box className='calendly'>
        <PopupWidget
          url='https://calendly.com/contact-datayaan/yaantrac-one2one'
          rootElement={document.getElementById('root')!}
          text={icon}
        />
      </Box>
    </>
  );
};

export default CalendarDemo;
